function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M45.61 81c-2.98 0-31.36-13.98-31.36-52.74L45.34 15l31.09 13.26C76.43 68.54 48.59 81 45.61 81z",
  stroke: "#ccc0fd",
  strokeWidth: 2,
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M45.72 94C41.56 94 2 74.51 2 20.48L45.34 2l43.34 18.48C88.68 76.63 49.87 94 45.71 94z",
  stroke: "#63c",
  strokeWidth: 4,
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M45.45 61.27c-1.2 0-12.61-5.62-12.61-21.2l12.5-5.33 12.5 5.33c0 16.19-11.19 21.2-12.39 21.2z",
  fill: "#00ffcb",
  stroke: "#63c",
  strokeWidth: 4
}));

function SvgShield(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 90.68 96"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgOTAuNjggOTYiPgogICAgPGRlZnM+CiAgICAgICAgPHN0eWxlPgogICAgICAgICAgICAuY2xzLTEsLmNscy0ye2ZpbGw6bm9uZTt9LmNscy0xLC5jbHMtMiwuY2xzLTN7c3Ryb2tlLWxpbmVqb2luOnJvdW5kO30uY2xzLTEsLmNscy0ze3N0cm9rZTojNjNjO3N0cm9rZS13aWR0aDo0cHg7fS5jbHMtMntzdHJva2U6I2NjYzBmZDtzdHJva2Utd2lkdGg6MnB4O30uY2xzLTN7ZmlsbDojMDBmZmNiO308L3N0eWxlPgogICAgPC9kZWZzPgogICAgPGcgaWQ9IkxheWVyXzEtMiI+CiAgICAgICAgPGc+CiAgICAgICAgICAgIDxwYXRoIGNsYXNzPSJjbHMtMiIKICAgICAgICAgICAgICAgIGQ9Ik00NS42MSw4MWMtMi45OCwwLTMxLjM2LTEzLjk4LTMxLjM2LTUyLjc0bDMxLjA5LTEzLjI2LDMxLjA5LDEzLjI2YzAsNDAuMjgtMjcuODQsNTIuNzQtMzAuODIsNTIuNzRaIiAvPgogICAgICAgICAgICA8cGF0aCBjbGFzcz0iY2xzLTEiCiAgICAgICAgICAgICAgICBkPSJNNDUuNzIsOTRjLTQuMTYsMC00My43Mi0xOS40OS00My43Mi03My41Mkw0NS4zNCwybDQzLjM0LDE4LjQ4YzAsNTYuMTUtMzguODEsNzMuNTItNDIuOTcsNzMuNTJaIiAvPgogICAgICAgICAgICA8cGF0aCBjbGFzcz0iY2xzLTMiCiAgICAgICAgICAgICAgICBkPSJNNDUuNDUsNjEuMjdjLTEuMiwwLTEyLjYxLTUuNjItMTIuNjEtMjEuMmwxMi41LTUuMzMsMTIuNSw1LjMzYzAsMTYuMTktMTEuMTksMjEuMi0xMi4zOSwyMS4yWiIgLz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg==";
export { SvgShield as ReactComponent };